import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import { useSearchParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSelect-root": {
			backgroundColor: "#FFF",
		},
	},
	formControl: {
		width: "100%",
	},
}));

const StatusList = [
	{ code: "All", status: "All" },
	{ code: "O", status: "Open" },
	{ code: "S", status: "Submitted" },
	{ code: "A", status: "Approved" },
];

type Props = {};

export const StatusFilter = ({}: Props) => {
	const classes = useStyles();
	const [searchParams, setSearchParams] = useSearchParams();

	const statusCode = searchParams.get("status") ?? "";

	const handleFilter = (e: React.ChangeEvent<{ value: unknown }>) => {
		searchParams.set("status", e.target.value as string);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<div className={classes.root} style={{ marginTop: 8 }}>
			<FormControl
				variant="outlined"
				margin="dense"
				className={classes.formControl}
			>
				<InputLabel id="status-select-label">Status</InputLabel>
				<Select
					labelId="status-select-label"
					id="status-select"
					value={statusCode}
					onChange={handleFilter}
					label="Status"
					displayEmpty
				>
					{StatusList.map((status) => (
						<MenuItem key={`status-${status?.code}`} value={status?.code}>
							{status?.status}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};
